(function () {
  'use strict';

  var apiKey = 'PyramidialStickyAnnouncements';
  var sectionSelector = '.shopify-section-announcement-bar-container';
  var barSelector = '.shopify-section-announcement-bar';
  var heightProperty = '--pyramidial-announcement-height';

  if (window[apiKey]) {
    window[apiKey].refresh();
    return;
  }

  var controllers = new Map();
  var frame = null;

  function isVisible(element) {
    if (!element || !element.isConnected || element.hidden) return false;
    var style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function Controller(section) {
    this.section = section;
    this.bar = null;
    this.resizeObserver = 'ResizeObserver' in window
      ? new ResizeObserver(scheduleLayout)
      : null;
    this.mutationObserver = new MutationObserver(function (mutations) {
      var onlyOwnLayoutWrites = mutations.every(function (mutation) {
        return mutation.type === 'attributes'
          && mutation.target === section
          && mutation.attributeName === 'style';
      });
      if (!onlyOwnLayoutWrites) this.sync();
    }.bind(this));
    this.mutationObserver.observe(section, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'hidden']
    });
    this.sync();
  }

  Controller.prototype.sync = function () {
    var nextBar = this.section.querySelector(barSelector);
    if (this.bar !== nextBar) {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      this.bar = nextBar;
      if (this.resizeObserver && this.bar) this.resizeObserver.observe(this.bar);
    }
    scheduleLayout();
  };

  Controller.prototype.height = function () {
    if (!isVisible(this.section) || !isVisible(this.bar)) return 0;
    return Math.ceil(this.bar.getBoundingClientRect().height);
  };

  Controller.prototype.cleanup = function () {
    this.mutationObserver.disconnect();
    if (this.resizeObserver) this.resizeObserver.disconnect();
    this.section.style.removeProperty('--pyramidial-announcement-instance-height');
    this.section.style.removeProperty('--pyramidial-announcement-instance-top');
  };

  function orderedControllers() {
    return Array.from(controllers.values()).sort(function (left, right) {
      if (left.section === right.section) return 0;
      var position = left.section.compareDocumentPosition(right.section);
      return position & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
  }

  function layout() {
    frame = null;
    var top = 0;
    orderedControllers().forEach(function (controller) {
      var height = controller.height();
      controller.section.style.setProperty(
        '--pyramidial-announcement-instance-top', top + 'px'
      );
      controller.section.style.setProperty(
        '--pyramidial-announcement-instance-height', height + 'px'
      );
      top += height;
    });
    document.documentElement.style.setProperty(heightProperty, top + 'px');
  }

  function scheduleLayout() {
    if (frame !== null) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(layout);
  }

  function refresh() {
    var present = new Set(document.querySelectorAll(sectionSelector));
    controllers.forEach(function (controller, section) {
      if (!present.has(section)) {
        controller.cleanup();
        controllers.delete(section);
      }
    });
    present.forEach(function (section) {
      if (!controllers.has(section)) {
        controllers.set(section, new Controller(section));
      }
    });
    scheduleLayout();
  }

  function unload(section) {
    var controller = controllers.get(section);
    if (!controller) return;
    controller.cleanup();
    controllers.delete(section);
    scheduleLayout();
  }

  function eventSection(event) {
    return event.target && event.target.matches
      && event.target.matches(sectionSelector) ? event.target : null;
  }

  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:reorder', refresh);
  document.addEventListener('shopify:section:unload', function (event) {
    var section = eventSection(event);
    if (section) unload(section);
  });
  window.addEventListener('resize', scheduleLayout, { passive: true });
  window.addEventListener('pageshow', refresh);

  var documentObserver = new MutationObserver(function (mutations) {
    var changed = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes))
        .some(function (node) {
          return node.nodeType === Node.ELEMENT_NODE
            && (node.matches(sectionSelector) || node.querySelector(sectionSelector));
        });
    });
    if (changed) refresh();
  });
  var rootClassObserver = new MutationObserver(scheduleLayout);

  function start() {
    documentObserver.observe(document.documentElement, { childList: true, subtree: true });
    rootClassObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });
    refresh();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleLayout);
    }
  }

  window[apiKey] = {
    refresh: refresh,
    measure: scheduleLayout,
    instanceCount: function () { return controllers.size; }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
